import { isAdOps } from '../../layout/Variant/Variant';
import { getOperativeSystem } from '../../products/utils';
import { getOffSiteMinBudgetSpecification } from '../../quote-editor/utils/offsite-min-budget';
import getEventTargetValue from '../../utils/get-event-target-value';
import { changeCampaign, changeCampaignLine } from '../actions';
import { connectEditor } from '../connect-editor';
import { campaignLineStatuses } from '../constants';
import {
  checkZmsAmOperativeSystem,
  getBudgetTotals,
  getLinesForProduct,
  getMaxEndDate,
  getMinStartDate,
  getOpsHandoverCompliance,
  getSpentBudgetForProduct,
} from '../utils';
import ProductLine from './ProductLine';

const mapStateToProps = (state, props) => {
  const {
    campaign,
    campaignLinesById,
    campaignUI: { expansionStateByLabel, downstreamSystemLinks },
  } = state;

  const lines = getLinesForProduct(props, campaignLinesById);
  const { product, offerType } = lines[0];
  const {
    code,
    id,
    supportsHighlightedSKUs,
    supportsOutfitIds,
    supportsCreativeCollabaryId,
    supportsCreativeProductionBudgetBreakdown,
    supportsCreativeEnhancedProductShootingBudgetBreakdown,
    supportsCreativeLandingPageBudgetBreakdown,
    supportsNumberOfURLs,
    supportsCollectionIds,
    base14DayBudget,
    additional14DayBudgetPerCountry,
    supportsOfferTypes,
    supportsContentIds,
    supportsAdManager,
  } = product;

  const budgetTotals = getBudgetTotals(lines);
  const spentBudget = getSpentBudgetForProduct(campaign, product);
  const opsHandoverCompliance = getOpsHandoverCompliance(lines);
  const operativeSystem = getOperativeSystem(product);
  const {
    excludeDiscountedSKUs,
    merchantExclusivity,
    highlightedSkus,
    filterOnSupplierCode,
    steerOnSupplierCode,
    productMetas,
    outfitIds,
    promoteOnlyDiscountedSKUs,
  } = campaign;

  const productMeta = productMetas.find(pm => pm.productId === id);
  const productMetaWithIndex = productMeta
    ? {
        ...productMeta,
        index: productMetas.findIndex(pm => pm.productId === id),
      }
    : undefined;

  const hasPushedLines = lines.some(
    line => line.status === campaignLineStatuses.PUSHED,
  );

  const isZmsAm = checkZmsAmOperativeSystem(campaign, lines);

  return {
    product: {
      code,
      operativeSystem,
      isZmsAmPushable: isZmsAm,
      supportsCreativeCollabaryId,
      supportsCreativeProductionBudgetBreakdown,
      supportsCreativeEnhancedProductShootingBudgetBreakdown,
      supportsCreativeLandingPageBudgetBreakdown,
      supportsHighlightedSKUs,
      supportsNumberOfURLs,
      supportsOutfitIds,
      supportsCollectionIds,
      supportsOfferTypes,
      supportsContentIds,
      supportsAdManager,
    },
    ...budgetTotals,
    spentBudget,
    offSiteMinBudgetSpecification: getOffSiteMinBudgetSpecification(
      base14DayBudget,
      additional14DayBudgetPerCountry,
    ),
    minStartDate: getMinStartDate(lines),
    maxEndDate: getMaxEndDate(lines),
    isPureGrowthCampaign: state.campaign.opportunity.useCase === 'Pure Growth',
    isSelectionBoostCampaign:
      state.campaign.opportunity.useCase === 'Selection Boost',
    isWholesale: state.campaign.opportunity.businessModel === 'Wholesale',
    isHybrid: state.campaign.opportunity.businessModel === 'Hybrid',
    isMerchantExclusivityEditable:
      state.campaign.opportunity.businessModel === 'Partner Program' ||
      state.campaign.opportunity.businessModel === 'Hybrid' ||
      state.campaign.opportunity.businessModel === 'Connected Retail',
    excludeDiscountedSKUs,
    merchantExclusivity,
    filterOnSupplierCode,
    promoteOnlyDiscountedSKUs,
    highlightedSkus,
    campaignId: campaign.id,
    expanded: expansionStateByLabel[props.label],
    status: lines[0].status,
    steerOnSupplierCode,
    productMeta: productMetaWithIndex,
    linkToDownstreamSystem:
      hasPushedLines && isAdOps() ? downstreamSystemLinks[operativeSystem] : '',
    outfitIds,
    opsHandoverCompliance,
    offerType,
    lines,
  };
};

const mapDispatchToProps = dispatch => ({
  onChangeCampaignLine: event =>
    dispatch(
      changeCampaignLine(event.target.name, getEventTargetValue(event.target)),
    ),
  onChangeCampaign: event =>
    dispatch(
      changeCampaign(event.target.name, getEventTargetValue(event.target)),
    ),
});

export default connectEditor(mapStateToProps, mapDispatchToProps)(ProductLine);
